import React, { useContext, useEffect } from 'react';
import Map from '../Map/Map';
import { Outlet, useParams } from 'react-router-dom';
import AppContext from '../data/AppContext';
import '../App.css';
import BottomSheet from '../components/bottom-sheet.component';
import SiteHeader from '../components/site-header.component';

const MapWithSidebar = () => {
  const { mountainId } = useParams();
  const { setActiveMountain } = useContext(AppContext);

  useEffect(() => {
    setActiveMountain(mountainId);
  }, [mountainId, setActiveMountain]);

  return (
    <div className={'page'}>
      <SiteHeader />
      <div className={'element map'}>
        <Map />
      </div>

      <div className={'element sidebar'}>
        <BottomSheet>
          <Outlet />
        </BottomSheet>
      </div>
    </div>
  );
};

export default MapWithSidebar;
